import {styled} from '@mui/system';
import {CardHeader} from '@mui/material';

export const MuiTechnicianSettingsCardHeader = styled(CardHeader)(() => ({
	paddingBottom: 0,
}));
